var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-error-massage",class:_vm.getClass},[_c('div',{staticClass:"order-error-massage_icon"},[_vm._v("!")]),_vm._v(" "),_c('div',{staticClass:"order-error-massage_errors",domProps:{"innerHTML":_vm._s(_vm.getErrorsHtml)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73ed483d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-svg-inline-loader/dist/index.min.js!./src/components/Order/ErrorMessage.vue
// module id = lYKH
// module chunks = 1